/**
 * Render stored conversation message text as safe HTML for ThreadPane bubbles.
 * Pipeline: sanitize → logo placeholders → escape plaintext → linkify → restore img → br.
 * Mirrors trusted transforms from functions-forms/src/shared/htmlUtils.ts bodyToHtml.
 */

const LOGO_URL_RE = /\[Logo:\s*(https?:\/\/[^\]\s"'<>]+)\]/gi;
const BARE_URL_RE = /(?<!__LOGO_PLACEHOLDER_\d+__)(https?:\/\/[^\s<>"'&]+)/g;
const LINK_STYLE = 'color: #0066cc; text-decoration: none;';
const IMG_STYLE = 'max-height: 50px; max-width: 200px;';

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Escape a URL for safe use inside an HTML attribute (defense in depth). */
function escapeAttr(url) {
  return String(url)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function sanitizeRaw(text) {
  if (text == null) return '';
  return String(text)
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/\s*on\w+\s*=\s*["'][^"']*["']/gi, '')
    .replace(/javascript:/gi, '');
}

/**
 * @param {string|null|undefined} text
 * @returns {string}
 */
export function renderMessageHtml(text) {
  let processed = sanitizeRaw(text);
  if (!processed) return '';

  const logoPlaceholders = [];
  processed = processed.replace(LOGO_URL_RE, (_match, url) => {
    const placeholder = `__LOGO_PLACEHOLDER_${logoPlaceholders.length}__`;
    logoPlaceholders.push({ placeholder, url });
    return placeholder;
  });

  processed = escapeHtml(processed);

  processed = processed.replace(
    BARE_URL_RE,
    '<a href="$1" style="' + LINK_STYLE + '">$1</a>'
  );

  for (const { placeholder, url } of logoPlaceholders) {
    const safeSrc = escapeAttr(url);
    processed = processed.replace(
      placeholder,
      '<img src="' + safeSrc + '" alt="Logo" style="' + IMG_STYLE + '" />'
    );
  }

  processed = processed.replace(/\n/g, '<br>');

  return processed;
}
